import { TYPE } from "../tokens";

export default function SectionHeader({ label, title, maxWidth }) {
  return (
    <div style={{ marginBottom: "clamp(40px, 5vw, 64px)" }}>
      <div style={TYPE.sectionLabel}>{label}</div>
      <h2 style={{ ...TYPE.sectionHeading, maxWidth }}>{title}</h2>
    </div>
  );
}
